<template>
  <div>
      <div class="column">
          <b-field grouped>
            <b-field >
              <b-switch v-model="showGroupingBar">
                {{ showGroupingBar ? 'Filtros Visibles' : 'Filtros Ocultos'}}
              </b-switch>
            </b-field>
            <b-field label="Año" label-position="inside">
              <b-input v-model="filters.year"></b-input>
            </b-field>
            <p class="control">
                <button class="button is-primary" @click="onClick">Filtrar</button>
            </p>
        </b-field>
      </div>
    <div class="control-section" style="overflow: auto" v-show="!isLoading">
      <div class="content-wrapper">
        <ejs-pivotview
          :key="`pivot-table-${keyTable}`"
          ref="pivotview" id="pivotview"
          locale="es"
          :showFieldList="showFieldList"
          :showGroupingBar="showGroupingBar"
          :dataSourceSettings="dataSourceSettings"
          :gridSettings="gridSettings"
          :showToolbar="showToolbar"
          :toolbar="toolbar"
          :height="height"
          width="100%"
          :allowExcelExport="allowExcelExport"
          :allowConditionalFormatting="allowConditionalFormatting"
          :allowPdfExport="allowPdfExport"
          :allowNumberFormatting="allowNumberFormatting"
          :allowCalculatedField="allowCalculatedField"
          :saveReport="saveReport"
          :loadReport="loadReport"
          :fetchReport="fetchReport"
          :renameReport="renameReport"
          :removeReport="removeReport"
          :newReport="newReport"
          :displayOption="displayOption"
          :toolbarClick="toolbarClick"
          >
        </ejs-pivotview>
      </div>
    </div>
    <div style="min-height: 200px;" v-if="isLoading">
      <b-loading :is-full-page="false" :active="isLoading" :can-cancel="false"></b-loading>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import DwExericeSevice from '@/services/DwExerciseDetailService.js'
import {
  PivotViewPlugin,
  GroupingBar,
  FieldList,
  CalculatedField,
  Toolbar,
  PDFExport,
  ExcelExport,
  ConditionalFormatting,
  NumberFormatting
  // IDataSet
} from '@syncfusion/ej2-vue-pivotview'

import { enableRipple, L10n } from '@syncfusion/ej2-base'
import * as EJ2_LOCALE from 'ej2-locale/src/es.json'

L10n.load({ es: EJ2_LOCALE.es })

enableRipple(false)

Vue.use(PivotViewPlugin)

export default Vue.extend({
  props: {
    records: {
      type: Array,
      default: () => []
    }
  },
  created () {
    // No year filter by default: filtering to the current year hid every
    // row whenever there was no data yet for that year, making the report
    // look broken. Show everything and let the user narrow it down with
    // the "Año" field above.
    this.setDetails()
  },
  data: () => {
    return {
      isLoading: false,
      keyTable: 1,
      dataSourceSettings: {
        dataSource: null,
        expandAll: false,
        filters: [
          { name: 'event_name', caption: 'Nombre Evento' },
          { name: 'year', caption: 'Año' },
          { name: 'month', caption: 'Mes' },
          { name: 'day', caption: 'Dia' },
          { name: 'start_estimated', caption: 'Hora Inicio' },
          { name: 'date_estimated', caption: 'Fecha' },
          { name: 'rider_name', caption: 'Nombre Jinete' },
          { name: 'rider_lastname', caption: 'Apellido Jinete' },
          { name: 'judge_name', caption: 'Nombre Juez' },
          { name: 'judge_lastname', caption: 'Apellido Juez' },
          { name: 'official', caption: 'Oficial' },
          { name: 'exercise_id', caption: 'Id Ejercicio' },
          { name: 'exercise_order', caption: 'Orden Ejercicio' },
          { name: 'coefficient', caption: 'Coeficiente' }
        ],
        excludeFields: [
        ],
        columns: [{ name: 'horse_name', caption: 'Caballo' }],
        rows: [
          { name: 'year', caption: 'Año' },
          { name: 'lesson_name', caption: 'Evaluación' },
          { name: 'exercise_name', caption: 'Ejercicio' }
        ],
        formatSettings: [
          { name: 'base_score', format: '#.0' },
          { name: 'total_score', format: '#.0' }
        ],
        values: [
          { name: 'base_score', caption: 'Puntaje Base', type: 'Avg' },
          { name: 'total_score', caption: 'Puntaje Total', type: 'Avg' }
        ],
        filterSettings: [],
        allowLabelFilter: true
      },
      gridSettings: { columnWidth: 120 },
      height: 500,
      width: '100%',
      showFieldList: false,
      showGroupingBar: false,
      showToolbar: true,
      aggregateTypes: ['Avg', 'Product'],
      allowExcelExport: true,
      allowConditionalFormatting: true,
      allowNumberFormatting: true,
      allowPdfExport: true,
      displayOption: { view: 'Both' },
      allowCalculatedField: true,
      toolbar: [
        'New',
        'Save',
        'SaveAs',
        'Rename',
        'Remove',
        'Load',
        'Grid',
        'Chart',
        'Export',
        'SubTotal',
        'GrandTotal',
        'ConditionalFormatting',
        'NumberFormatting',
        'FieldList'
      ],
      filters: {
        year: null,
        horse: null
      }
    }
  },
  methods: {
    async setDetails () {
      this.isLoading = true
      let response = await DwExericeSevice.getExerciseDetails()
      this.dataSourceSettings.dataSource = response.data.data
      this.showFieldList = true
      this.showGroupingBar = false
      this.$nextTick(() => {
        this.refreshTable()
        this.isLoading = false
      })
    },
    refreshTable () {
      this.keyTable++
    },
    toolbarClick (args) {
      console.log(args.item.id)
      // if (args.item.id === 'GanttContainer_excelexport') {
      //   var excelExportProperties = {
      //     fileName: 'Gantt.xlsx'
      //   }
      //   var ganttObj = document.getElementById('GanttContainer').ej2_instances[0]
      //   ganttObj.excelExport(excelExportProperties)
      // } else if (args.item.id === 'GanttContainer_csvexport') {
      //   var excelExportProperties = {
      //     fileName: 'Gantt.csv'
      //   }
      //   var ganttObj = document.getElementById('GanttContainer').ej2_instances[0]
      //   ganttObj.csvExport(excelExportProperties)
      // }
    },
    saveReport: function (args) {
      let reports = []
      let isSaved = false
      if (
        localStorage.pivotviewReports &&
        localStorage.pivotviewReports !== ''
      ) {
        reports = JSON.parse(localStorage.pivotviewReports)
      }
      if (args.report && args.reportName && args.reportName !== '') {
        reports.map(function (item) {
          if (args.reportName === item.reportName) {
            item.report = args.report
            isSaved = true
          }
        })
        if (!isSaved) {
          reports.push(args)
        }
        localStorage.pivotviewReports = JSON.stringify(reports)
      }
    },
    fetchReport: function (args) {
      let reportCollection = []
      let reeportList = []
      if (
        localStorage.pivotviewReports &&
        localStorage.pivotviewReports !== ''
      ) {
        reportCollection = JSON.parse(localStorage.pivotviewReports)
      }
      reportCollection.map(function (item) {
        reeportList.push(item.reportName)
      })
      args.reportName = reeportList
    },
    loadReport: function (args) {
      let pivotObj = document.getElementById('pivotview').ej2_instances[0]
      let reportCollection = []
      if (
        localStorage.pivotviewReports &&
        localStorage.pivotviewReports !== ''
      ) {
        reportCollection = JSON.parse(localStorage.pivotviewReports)
      }
      reportCollection.map(function (item) {
        if (args.reportName === item.reportName) {
          args.report = item.report
        }
      })
      if (args.report) {
        pivotObj.dataSourceSettings = JSON.parse(args.report).dataSourceSettings
      }
    },
    removeReport: function (args) {
      let reportCollection = []
      if (
        localStorage.pivotviewReports &&
        localStorage.pivotviewReports !== ''
      ) {
        reportCollection = JSON.parse(localStorage.pivotviewReports)
      }
      for (let i = 0; i < reportCollection.length; i++) {
        if (reportCollection[i].reportName === args.reportName) {
          reportCollection.splice(i, 1)
        }
      }
      if (
        localStorage.pivotviewReports &&
        localStorage.pivotviewReports !== ''
      ) {
        localStorage.pivotviewReports = JSON.stringify(reportCollection)
      }
    },
    renameReport: function (args) {
      let reportCollection = []
      if (
        localStorage.pivotviewReports &&
        localStorage.pivotviewReports !== ''
      ) {
        reportCollection = JSON.parse(localStorage.pivotviewReports)
      }
      reportCollection.map(function (item) {
        if (args.reportName === item.reportName) {
          item.reportName = args.rename
        }
      })
      if (
        localStorage.pivotviewReports &&
        localStorage.pivotviewReports !== ''
      ) {
        localStorage.pivotviewReports = JSON.stringify(reportCollection)
      }
    },
    newReport: function () {
      let pivotGridObj = document.getElementById('pivotview').ej2_instances[0]
      pivotGridObj.setProperties(
        {
          dataSourceSettings: {
            columns: [],
            rows: [],
            values: [],
            filters: []
          }
        },
        false
      )
    },
    onClick () {
      let pivotObj = this.$refs.pivotview
      let filters = []
      if (this.filters.year) {
        filters = [{ name: 'year', type: 'Label', condition: 'Equals', value1: this.filters.year }]
      }
      pivotObj.dataSourceSettings.filterSettings = filters
      this.$nextTick(() => {
        this.refreshTable()
        this.isLoading = false
      })
    }
  },
  watch: {
    showGroupingBar () {
      this.$nextTick(() => {
        this.refreshTable()
      })
    }
  },
  provide: {
    pivotview: [
      FieldList,
      CalculatedField,
      Toolbar,
      PDFExport,
      ExcelExport,
      ConditionalFormatting,
      NumberFormatting,
      GroupingBar
    ]
  }
})
</script>

<style scoped>
  #pivotview, #pivotview_grid {
    width: 100% !important;
    min-width: 100% !important;
  }

  .sb-sample-content-area {
    min-height: 255px !important;
  }
  .control-section {
    min-height: 255px !important;
  }

</style>
